export default __webpack_public_path__ + "static/media/icon-blue-outline-check.f2e8d0ae.svg";